export default {
    loadFamiliesDefinition: 'FAMILIES_CATEGORIES_DEFINITION',
    selectManualFamily: 'SELECT_MANUAL_FAMILY',
    unselectPredictionFamilyAndCategory: 'UNSELECT_PREDICTION_FAMILY_AND_CATEGORY',
    selectPredictionFamilyAndCategory: 'SELECT_PREDICTION_FAMILY_AND_CATEGORY',
    selectManualCategories: 'SELECT_MANUAL_CATEGORIES',
    unselectManualCategories: 'UNSELECT_MANUAL_CATEGORIES',
    selectManualSuggestedCategory: 'SELECT_MANUAL_SUGGESTED_CATEGORY',
    clearFamiliesAndCategories: 'CLEAR_FAMILIES_AND_CATEGORIES',
    switchToCategoryPrediction: 'SWITCH_TO_CATEGORY_PREDICTION',
    switchToCategoryManual: 'SWITCH_TO_CATEGORY_MANUAL',
    selectAddress: 'SELECT_ADDRESS',
    selectExperienceLevel: 'SELECT_EXPERIENCE_LEVEL',
    unselectExperienceLevel: 'UNSELECT_EXPERIENCE_LEVEL',
    selectPrice: 'SELECT_PRICE',
    selectPriceHide: 'SELECT_PRICE_HIDE',
    selectPhone: 'SELECT_PHONE',
    removePhone: 'REMOVE_PHONE',
    selectTag: 'SELECT_TAG',
    selectWorkplacePreference: 'SELECT_WORKPLACE_PREFERENCE',
    unselectTag: 'UNSELECT_TAG',
    selectInvitationCode: 'SELECT_INVITATION_CODE',
    resetDetails: 'RESET_DETAILS',
    resetDetailsInPredictor: 'RESET_DETAILS_IN_PREDICTOR',
    changeLanguages: 'CHANGE_LANGUAGES',
    updateIndustryExpertises: 'UPDATE_INDUSTRY_EXPERTISE',
    updateFunctionalSkills: 'UPDATE_FUNCTIONAL_SKILLS',
    updateHeadline: 'UPDATE_HEADLINE',
    updateWillingnessToTravelInternationally: 'UPDATE_WILLINGNESS_TO_TRAVEL_INTERNATIONALLY',
    updateStrategyBackground: 'UPDATE_STRATEGY_BACKGROUND',
    definePriceConfiguration: 'DEFINE_PRICE_CONFIGURATION',
    updateCorporateProgram: 'UPDATE_CORPORATE_PROGRAM',
    updateProfileCreationResumptionDetails: 'UPDATE_PROFILE_CREATION_RESUMPTION_DETAILS',
};
